import { useEffect, useMemo, useState } from "react";
import { Timer } from "lucide-react";

function useNow() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  return now;
}

export default function Countdown({ matches }) {
  const now = useNow();

  const next = useMemo(() => {
    return (matches || [])
      .filter((m) => m.status === "À VENIR" && m.match_datetime)
      .map((m) => ({ ...m, ts: new Date(m.match_datetime).getTime() }))
      .filter((m) => !Number.isNaN(m.ts) && m.ts > Date.now())
      .sort((a, b) => a.ts - b.ts)[0];
  }, [matches]);

  if (!next) return null;

  const diff = Math.max(0, next.ts - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  return (
    <div data-testid="match-countdown" className="card-tactical glow-orange mt-10 max-w-xl p-5">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-orange-500">
        <Timer className="h-4 w-4" /> Prochain match — {next.event}
      </p>
      <p className="mt-1 font-heading text-lg font-bold uppercase">
        Emisphere <span className="text-orange-500">vs</span> {next.opponent}
      </p>
      <div className="mt-4 grid grid-cols-4 gap-2 text-center">
        {[[days, "Jours"], [hours, "Heures"], [minutes, "Min"], [seconds, "Sec"]].map(([v, l]) => (
          <div key={l} className="rounded-lg border border-orange-500/20 bg-[#060B18] py-3">
            <p className="font-mono2 text-2xl font-bold text-white">{String(v).padStart(2, "0")}</p>
            <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500">{l}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
